/**
 * Tintable wheelchair pictogram shared by stop boarding badges and P+R amenity chips.
 */

import React from "react";
import { WHEELCHAIR_ICON_PATH, WHEELCHAIR_ICON_VIEW_BOX } from "./wheelchairIcon.paths";

interface WheelchairIconProps {

    /** Fill color applied to the pictogram. */
    "color": string;

    /** Optional CSS class for sizing. Defaults to a compact amenity-chip size. */
    "className"?: string;
}

/**
 * Renders a filled wheelchair pictogram tinted via {@link WheelchairIconProps.color}.
 *
 * @param props Icon props.
 * @returns Inline SVG icon.
 */
const WheelchairIcon: React.FC<WheelchairIconProps> = ( {
    color,
    className = "h-3 w-3",
} ) => {
    return (
        <svg
            aria-hidden={true}
            className={className}
            fill={color}
            viewBox={WHEELCHAIR_ICON_VIEW_BOX}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d={WHEELCHAIR_ICON_PATH} />
        </svg>
    );
};

export default WheelchairIcon;
